import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5498ec2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ion-text-center ion-padding"
}
const _hoisted_2 = {
  key: 1,
  class: "ion-text-center ion-padding empty-state"
}
const _hoisted_3 = { class: "empty-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty-subtitle" }, "Torna più tardi per nuovi contenuti.", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("NUOVO ")

import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCard,
  IonImg,
  IonCardContent,
  IonRefresher,
  IonRefresherContent,
  IonModal,
  IonIcon,
  IonItem,
  IonBadge,
  IonSpinner,
  modalController,
} from '@ionic/vue';
import {
  caretForwardCircleOutline,
  documentOutline,
} from 'ionicons/icons';
import FileService from "@/api/file/FileService";
import fileModal from "@/views/file/fileModal.vue";
import {loadingController} from "@ionic/vue";
import {computed, ref} from 'vue';
import {Browser} from '@capacitor/browser/';
import {FileOpener} from "@awesome-cordova-plugins/file-opener";
import {Filesystem, Directory} from '@capacitor/filesystem';
import {useRoute} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const {
  argumentFileType,
  fetchPDF,
  fetchFile,
  getCurrentFile,
  handleFileIcon,
} = FileService()
const isLoading = ref(true)
const files = computed(() => getCurrentFile() || [])
const hasFiles = computed(() => files.value.length > 0)
const emptyTitle = computed(() => {
  const typeLabel = route.meta.type === 'training' ? 'training' : 'pressroom'
  return `Nessun ${typeLabel} disponibile`
})

const loadFiles = async () => {
  isLoading.value = true
  try {
    await fetchFile()
  } finally {
    isLoading.value = false
  }
}

argumentFileType.value = route.meta.type
loadFiles()

const doRefresh = (event: any) => {
  loadFiles()
  setTimeout(() => {
    if (event.target !== null) {
      event.target.complete();
    }
  }, 2000);
}

async function openFileModal(file) {
  const modal = await modalController
      .create({
        component: fileModal,
        componentProps: {
          file: file
        },
        cssClass: 'fullscreen'
      })
  return modal.present();
}

//Loader che mi assicura che il PDF sia scaricato aspettando 2 secondi
async function presentLoading() {
  const loading = await loadingController
      .create({
        cssClass: 'my-custom-class',
        message: 'Attendere...',
        duration: 2000,
      });

  await loading.present();

  setTimeout(function () {
    loading.dismiss()
  }, 2000);
}

const openPDFWithBrowser = async (link) => {
  await Browser.open({url: link});
}

const openPDF = (blob, link) => { //salvo il pdf in locale e lo apro con File opener
  const reader = new FileReader()
  reader.readAsDataURL(blob)
  reader.onloadend = async function () {
    const base64data = reader.result || ''
    try {
      //Salvo il PDF in memoria
      const result = await Filesystem.writeFile({
        path: 'test',
        data: base64data.toString(),
        directory: Directory.Data,
        recursive: true,
      })
      FileOpener.open(result.uri, 'application/pdf')
          .catch(e => {
            console.log('Error opening file', e)
            //Se file opener non funziona apro il pdf tramite il Browser open
            openPDFWithBrowser(link)
          })
    } catch (e) {
      console.error('Unable to write file', e)
    }
  }
}

function openDocument(file) {
  if (file.type === 'file') {
    presentLoading()
    //scarico il blob del pdf
    fetchPDF(file.link).then((response: any) => {
      openPDF(response.data, file.link)
    })
  } else {
    openFileModal(file);
  }
}

const isOpenRef = ref(false);
const setOpen = (state: boolean) => {
  isOpenRef.value = state;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenuButton), { color: "primary" })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$route.meta.type), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: "training"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRefresher), {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (doRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRefresherContent))
            ]),
            _: 1
          }),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(IonSpinner), { name: "crescent" })
              ]))
            : (!_unref(hasFiles))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(emptyTitle)), 1),
                  _hoisted_4
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(files), (file) => {
                  return (_openBlock(), _createBlock(_unref(IonCard), {
                    key: file.id,
                    onClick: ($event: any) => (openDocument(file))
                  }, {
                    default: _withCtx(() => [
                      (file.new)
                        ? (_openBlock(), _createBlock(_unref(IonBadge), {
                            key: 0,
                            color: "danger",
                            style: {"position":"absolute","z-index":"2","top":"10px","right":"10px"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (file.preview_link)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_unref(IonImg), {
                              src: file.preview_link
                            }, null, 8, ["src"]),
                            _createVNode(_unref(IonCardContent), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(file.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ], 64))
                        : (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 2,
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                ios: _unref(handleFileIcon)(file.type).icon,
                                md: _unref(handleFileIcon)(file.type).icon,
                                size: "large"
                              }, null, 8, ["ios", "md"]),
                              _createVNode(_unref(IonCardContent), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(file.name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)),
                      _createVNode(_unref(IonModal), { "swipe-to-close": true }, {
                        default: _withCtx(() => [
                          _createVNode(fileModal, {
                            file: file,
                            onDismiss: _cache[1] || (_cache[1] = ($event: any) => (setOpen(false)))
                          }, null, 8, ["file"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})